import { useContext } from 'react';
import { Grid, Table, TableHead, TableCell, TableBody, TableRow } from '@material-ui/core';
import { applicationContext } from 'helpers/services';
import { ITicket } from '../TicketPrint';


interface IProps {
    ticket: ITicket
}

let BaseInfo = ({ ticket }: IProps) => {
    let { ticketStatuses, ticketPriorities, customerServiceUsers } = useContext(applicationContext);


    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Status</TableCell>
                        <TableCell>Priority</TableCell>
                        <TableCell>Who's Next</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow >
                        <TableCell>{ticketStatuses.getValueByKey(ticket.ticketStatusId, 'id', 'name')}</TableCell>
                        <TableCell>{ticketPriorities.getValueByKey(ticket.ticketPriorityId, 'id', 'description')}</TableCell>
                        <TableCell>{ticket.whosNext}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Reporter</TableCell>
                        <TableCell>Assignee</TableCell>
                        <TableCell>Customer service assignee</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow >
                        <TableCell>{ticket.reporter}</TableCell>
                        <TableCell>{customerServiceUsers.getValueByKey(ticket.customerServiceAssignee) || 'Not assigned'}</TableCell>
                        <TableCell>{customerServiceUsers.getValueByKey(ticket.customerServiceAssignee) || 'Not assigned'}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    )
}

export default BaseInfo;